import { useState, useEffect } from 'react';
import PlayerSetup from '../PlayerSetup/PlayerSetup';
import EmailSimulation from '../EmailSimulation/EmailSimulation';
import Dashboard from '../Dashboard/Dashboard';
import Header from '../Header/Header';
import DifficultySelect from '../DifficultySelect/DifficultySelect';
import '../../App.css';
import { fetchAllScenarios, fetchMe, logoutPlayer } from '../../services/api';

function App() {
  const [player, setPlayer] = useState(null);
  const [scenarios, setScenarios] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [finished, setFinished] = useState(false);
  const [levelUp, setLevelUp] = useState(null);
  const [showDashboard, setShowDashboard] = useState(false);
  const [selectedDifficulty, setSelectedDifficulty] = useState(null);

  useEffect(() => {
  fetchMe().then((existingPlayer) => {
    if (existingPlayer) setPlayer(existingPlayer);
  });
}, []);

  useEffect(() => {
  if (player && selectedDifficulty) {
    fetchAllScenarios(player.total_points, selectedDifficulty).then(setScenarios);
  }
}, [player, selectedDifficulty]);

  const handlePlayerCreated = (newPlayer) => {
    setPlayer(newPlayer);
  };

  const handleDifficultySelect = (difficulty) => {
  setSelectedDifficulty(difficulty);
  fetchAllScenarios(player.total_points, difficulty).then((data) => {
    // Zufällige Reihenfolge
    const shuffled = [...data].sort(() => Math.random() - 0.5);
    setScenarios(shuffled);
  });
};

  const handleNextScenario = (updatedPlayer) => {
    if (updatedPlayer && updatedPlayer.current_level !== player.current_level) {
      setLevelUp(updatedPlayer.current_level);
      setPlayer(updatedPlayer);
      setSelectedDifficulty(null);
      setCurrentIndex(0);
      setFinished(false);
      return;
    }
    setPlayer(updatedPlayer);
    if (currentIndex + 1 < scenarios.length) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setFinished(true);
    }
  };

  const handleBackToMenu = () => {
    setSelectedDifficulty(null);
    setCurrentIndex(0);
    setFinished(false);
    setScenarios([]);
  };

  const handleHome = async () => {
  await logoutPlayer();
  setPlayer(null);
  setScenarios([]);
  setCurrentIndex(0);
  setFinished(false);
  setLevelUp(null);
  setShowDashboard(false);
  setSelectedDifficulty(null);
};

  const renderContent = () => {
    if (showDashboard) {
      return <Dashboard player={player} onBack={() => setShowDashboard(false)} />;
    }

    if (levelUp) {
      return (
        <div className="center-box">
          <h2>🎉 Level-Aufstieg!</h2>
          <p>Du hast Level <strong>{levelUp}</strong> erreicht!<br />Neue Szenarien wurden freigeschaltet.</p>
          <button className="btn-primary" onClick={() => {
            setLevelUp(null);
          }}>
            Zum Menü →
          </button>
        </div>
      );
    }

    if (finished) {
      return (
        <div className="center-box">
          <h2>Alle Szenarien abgeschlossen!</h2>
          <p>Gesamtpunkte: <strong>{player.total_points}</strong> | Level: <strong>{player.current_level}</strong></p>
          <div className="btn-group">
            <button className="btn-primary" onClick={handleBackToMenu}>
              Nochmal spielen
            </button>
            <button className="btn-secondary" onClick={() => setShowDashboard(true)}>
              Dashboard anzeigen
            </button>
          </div>
        </div>
      );
    }

    if (!player) {
      return <PlayerSetup onPlayerCreated={handlePlayerCreated} />;
    }

    if (!selectedDifficulty) {
      return <DifficultySelect player={player} onSelect={handleDifficultySelect} />;
    }

    if (scenarios.length === 0) {
      return <p>Lade Szenarien...</p>;
    }

    return (
      <EmailSimulation
        player={player}
        scenarioId={scenarios[currentIndex].id}
        scenarioIndex={currentIndex}
        totalScenarios={scenarios.length}
        onNext={handleNextScenario}
        onBackToMenu={handleBackToMenu}
      />
    );
  };

  return (
    <div className="app">
      <Header
        player={player}
        onDashboard={() => setShowDashboard(true)}
        onHome={handleHome}
      />
      <main className="app-content">
        <div className="page-title">
          <h2>Phishing - Quiz</h2>
          <p>Phishing durchschauen. Risiken minimieren. Wissen vertiefen.</p>
        </div>
        {renderContent()}
      </main>
    </div>
  );
}

export default App;